import script from "./BotView.vue?vue&type=script&setup=true&lang=js"
export * from "./BotView.vue?vue&type=script&setup=true&lang=js"

import "./BotView.vue?vue&type=style&index=0&id=245d4cfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245d4cfa"]])

export default __exports__